import { Fragment, FunctionComponent, useContext, useEffect } from "react";
import { useHistory } from "react-router";
import { Background } from "../../components/container/background";
import { TopBar } from "../../components/topbar/top-bar";
import { useUser } from "../../components/user/user-context";
import { ROUTES } from "../../router/router";
import { OnboardingContext, OnboardingContextProvider } from "./context/onboarding-context";
import { OnboardingPageContent } from "./onboarding-page-content";

interface IOnboardingPageProps {}

export const OnboardingPage: FunctionComponent<IOnboardingPageProps> = (props) => {
  const history = useHistory();
  const { onboarded } = useContext(OnboardingContext);
  const { user } = useUser();
  const onboardedAt = user?.onboardedAt;

  useEffect(() => {
    if (onboarded || onboardedAt) {
      history.push(ROUTES.PORTAL.ROUTES.NUTRITION.PATH);
    }
  }, [history, onboarded, onboardedAt]);

  return (
    <Fragment>
      <Background showSkeleton>
        <TopBar hideActions />
        <OnboardingContextProvider>
          <OnboardingPageContent />
        </OnboardingContextProvider>
      </Background>
    </Fragment>
  );
};
